import { keyframes, styled } from "styled-components";

const animation = keyframes`
  from {
    opacity: 0;
    translate: 0 -24px;
  }

  to {
    opacity: 1;
    translate: 0 0;
  }
`;

export const Tabs = styled.div`
  border-bottom: var(--border);
  display: flex;
  position: relative;
  z-index: 0;
`;

export const TabItem = styled.div`
  align-items: center;
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-color: ${(props) => props.$active ? 'var(--color-theme-secondary-400)' : 'transparent'};
  cursor: pointer;
  display: flex;
  font-family: var(--font-family-display);
  font-weight: 600;
  gap: var(--space-1);
  height: var(--space-10);
  justify-content: center;
  padding-inline: var(--space-4);
  position: relative;
  z-index: 1;
`;

export const TabItemBadge = styled.div`
  align-items: center;
  aspect-ratio: 1;
  border-radius: 100%;
  color: var(--color-theme-secondary-400);
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  top: var(--space-3);
  translate: 0 -50%;
`;

export const TabContent = styled.div`
  animation-duration: 250ms;
  animation-name: ${animation};
  animation-timing-function: ease-in;
`;